import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedMatterInvestigationCreatedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';

export interface MatterInvestigationCreatedEventProps {
  event: DiscriminatedMatterInvestigationCreatedEvent;
}

export const MatterInvestigationCreatedEvent: React.FC<
  MatterInvestigationCreatedEventProps
> = ({ event }) => {
  const { investigation } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-yellow-100">
          <MagnifyingGlassIcon className="h-4 w-4 text-yellow-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      <ActivityDescription>
        {investigation.status && (
          <div className="text-sm text-gray-600">
            Status: {investigation.status.replace(/_/g, ' ')}
          </div>
        )}
        {investigation.description && (
          <div className="text-xs text-gray-500 italic">
            {investigation.description}
          </div>
        )}
      </ActivityDescription>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Investigation Started"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
